import React, { useMemo, useCallback } from 'react';
import { useFormContext, useFieldArray } from 'react-hook-form';
import { AddButton } from '@td-client-frontend/common';
import { DatePicker, ResizableTextArea } from '../../../../components/ReactHookForm';
import { defaultEmptyGroupCodes } from '../../../../utils/groups/incomingDataTransformation';
import { Add } from '@td-client-frontend/icons';

import { GroupCodes } from '../../../../@types/Groups';

export const AddCodesBody = () => {
  const { watch } = useFormContext();
  const addedCodes: GroupCodes[] = watch('newCodes');

  const { fields, remove, append } = useFieldArray({ name: 'newCodes' });

  const controlledFields: GroupCodes[] = useMemo(() => {
    return fields.map((field, index) => {
      return {
        ...addedCodes[index],
        ...field
      };
    });
  }, [addedCodes, fields]);

  const handleAdd = useCallback(() => append(defaultEmptyGroupCodes), [append]);

  return (
    <>
      {controlledFields.map((field, index) => {
        return (
          <div key={`${field.code}-${index}`} className="grid gap-4 grid-cols-12 border-b-1 border-gray">
            <ResizableTextArea maxHeight={8} name={`newCodes.${index}.code`} wrapperClasses="col-span-4 pt-3" />
            <DatePicker name={`newCodes.${index}.start_dt`} wrapperClasses="col-span-3 pt-3" placeholder="MM/DD/YYYY" />
            <DatePicker name={`newCodes.${index}.end_dt`} wrapperClasses="col-span-3 pt-3" placeholder="MM/DD/YYYY" />
            <div className="col-span-1">
              {addedCodes.length > 1 && (
                <button
                  type="button"
                  onClick={() => remove(index)}
                  className="flex transform rotate-45 w-6 h-6 mt-9 justify-self-center items-center focus:outline-none active:outline-none hover:transform hover:scale-110"
                >
                  <Add />
                </button>
              )}
            </div>
          </div>
        );
      })}
      <div className="flex w-full items-center justify-between">
        <AddButton label="Add new" onClick={handleAdd} />
      </div>
    </>
  );
};
